import { useContext } from 'react';
import { connect } from 'react-redux';
import { Button, Popover } from '@material-ui/core';

import toJs from '../../../hoc/toJS';

import { deleteProfileFromDepartment } from '../../../reducer/department/action';
import { DepartmentContext } from '../DepartmentContext';

function DepartmentDeleteMemberModal(props) {
  const {
    deleting,
    anchorEl,
    setAnchorEl,
    deleteProfileFromDepartment,
  } = props;

  const { selectedDepartmentId } = useContext(DepartmentContext);

  const handleSubmit = () => {
    setAnchorEl(null);
    deleteProfileFromDepartment(selectedDepartmentId, deleting);
  };

  return (
    <Popover
      open={anchorEl !== null}
      anchorEl={anchorEl}
      onClose={() => setAnchorEl(null)}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      transformOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <div style={{ padding: 8 }}>
        <div>Xác nhận xoá?</div>
        <div style={{ float: 'right', padding: '8px 0' }}>
          <Button
            size='small'
            variant='outlined'
            color='secondary'
            onClick={() => setAnchorEl(null)}
            style={{ marginRight: 4 }}
          >
            Huỷ
          </Button>
          <Button
            size='small'
            variant='outlined'
            color='primary'
            onClick={handleSubmit}
          >
            Xác nhận
          </Button>
        </div>
      </div>
    </Popover>
  );
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  deleteProfileFromDepartment: (departmentId, departmentProfileId) =>
    dispatch(deleteProfileFromDepartment(departmentId, departmentProfileId)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(toJs(DepartmentDeleteMemberModal));
